import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection, doc } from 'firebase/firestore'

export default class FormSection extends BaseModel {
  constructor() {
    super(collection(doc(collection(db, 'meta'), 'form_csv'), 'forms'))
  }
}
